import { diffLines } from "diff";

export function DiffView({ oldValue, newValue }: { oldValue: string | null; newValue: string | null }) {
  const parts = diffLines(oldValue ?? "", newValue ?? "");
  return (
    <div className="diff">
      {parts.flatMap((part, partIndex) => {
        const kind = part.added ? "added" : part.removed ? "removed" : "context";
        const marker = part.added ? "+" : part.removed ? "−" : " ";
        const lines = part.value.replace(/\n$/, "").split("\n");
        return lines.map((line, lineIndex) => (
          <div key={`${partIndex}-${lineIndex}`} className={`diff-line ${kind}`}>
            {marker} {line}
          </div>
        ));
      })}
    </div>
  );
}
